import { Box, styled } from '@mui/material';
import { LoadingButton } from 'components';

export const ProjectsListWrapper = styled(Box)(({ theme }) => ({
  overflowY: 'auto',
  paddingRight: theme.spacing(1),
}));

export const ButtonContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
}));

export const CustomLoadingButton = styled(LoadingButton)(({ theme }) => ({
  height: theme.spacing(5),
  padding: theme.spacing(1.3, 5),
  borderRadius: theme.spacing(3),
  color: theme.palette.common.white,
  borderColor: theme.palette.common.white,
  '&:hover': {
    borderColor: theme.palette.common.white,
  },
}));

export const LoaderContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
});
